import { render, staticRenderFns } from "./RolePermissionMatrix.vue?vue&type=template&id=1e10d428&"
import script from "./RolePermissionMatrix.vue?vue&type=script&lang=js&"
export * from "./RolePermissionMatrix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports